var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 340,
    height: 340,
    viewBox: "0 0 140 140",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116.667 33.543H81.667C79.2753 33.543 77.292 31.5596 77.292 29.168C77.292 26.7763 79.2753 24.793 81.667 24.793H116.667C119.059 24.793 121.042 26.7763 121.042 29.168C121.042 31.5596 119.059 33.543 116.667 33.543Z",
    fill: "#E6EAEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M99.167 51.043H81.667C79.2753 51.043 77.292 49.0596 77.292 46.668C77.292 44.2763 79.2753 42.293 81.667 42.293H99.167C101.559 42.293 103.542 44.2763 103.542 46.668C103.542 49.0596 101.559 51.043 99.167 51.043Z",
    fill: "#8392A2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0837 126.876C34.1253 126.876 7.29199 100.043 7.29199 67.0846C7.29199 34.1263 34.1253 7.29297 67.0837 7.29297C69.4753 7.29297 71.4587 9.2763 71.4587 11.668C71.4587 14.0596 69.4753 16.043 67.0837 16.043C38.9087 16.043 16.042 38.968 16.042 67.0846C16.042 95.2013 38.9087 118.126 67.0837 118.126C95.2587 118.126 118.125 95.2013 118.125 67.0846C118.125 64.693 120.109 62.7096 122.5 62.7096C124.892 62.7096 126.875 64.693 126.875 67.0846C126.875 100.043 100.042 126.876 67.0837 126.876Z",
    fill: "#8392A2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M128.334 132.707C127.225 132.707 126.117 132.298 125.242 131.423L113.575 119.757C111.884 118.065 111.884 115.265 113.575 113.573C115.267 111.882 118.067 111.882 119.759 113.573L131.425 125.24C133.117 126.932 133.117 129.732 131.425 131.423C130.55 132.298 129.442 132.707 128.334 132.707Z",
    fill: "#8392A2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/NoData.f93a831aea62bb8d00f6d6ab3d942ac3.svg";
export { ForwardRef as ReactComponent };